import enLocale from 'element-ui/lib/locale/lang/en';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';
import ukLocale from 'element-ui/lib/locale/lang/ua';
import ptLocale from 'element-ui/lib/locale/lang/pt';
import azLocale from 'element-ui/lib/locale/lang/az';
import plLocale from 'element-ui/lib/locale/lang/pl';
import jaLocale from 'element-ui/lib/locale/lang/ja';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhHantLocale from 'element-ui/lib/locale/lang/zh-TW';

export default {
  en: enLocale,
  ru: ruLocale,
  uk: ukLocale,
  pt: ptLocale,
  az: azLocale,
  pl: plLocale,
  ja: jaLocale,
  zh: zhLocale,
  zhHant: zhHantLocale,
};
